export function isPounds(currencyName?: string) {
  return ["pound sterling", "pound stirling", "£"].includes((currencyName ?? "").toLowerCase())
}

export function isEuros(currencyName?: string) {
  return ["euro", "euros", "€"].includes((currencyName ?? "").toLowerCase())
}

export function isDollars(currencyName?: string) {
  return ["dollar", "dollars", "us dollar", "us dollars", "$"].includes(
    (currencyName ?? "").toLowerCase(),
  )
}

//** Returns true if currency1 and currency2 are the same currency */
export function isCurrencyMatch(currency1?: string, currency2?: string) {
  return [isEuros, isPounds, isDollars].some(
    isCurrency => isCurrency(currency1) && isCurrency(currency2),
  )
}

export function convertPriceCurrency<T extends number | null>(
  price: T,
  conversionRate: number | null,
  currencyNameStart?: string,
  currencyNameEnd?: string,
) {
  function returnPrice(value: number | null) {
    if (!value) {
      return value
    }
    return Math.round(value)
  }
  const cRate = conversionRate ?? 1
  if (!price) {
    return price
  }
  if (isCurrencyMatch(currencyNameStart, currencyNameEnd)) {
    // console.log(
    //   "Price currency matches, no conversion needed",
    //   { currencyNameStart, currencyNameEnd },
    //   { price, conversionRate },
    // )
    return price
  }
  if (isEuros(currencyNameStart) && isPounds(currencyNameEnd)) {
    const newPrice = price * cRate
    // console.log("Converting price from", currencyNameStart, "to", currencyNameEnd, {
    //   price,
    //   rate: cRate,
    //   result: newPrice,
    // })
    return returnPrice(newPrice)
  }
  if (isPounds(currencyNameStart) && isEuros(currencyNameEnd)) {
    const newPrice = price / cRate
    // console.log("Converting price from", currencyNameStart, "to", currencyNameEnd, {
    //   price,
    //   rate: cRate,
    //   result: newPrice,
    // })
    return returnPrice(newPrice)
  }
  // console.log(
  //   `Skipped currency check: Unexpected currency names, "${currencyNameStart}" => "${currencyNameEnd}"`,
  // )
  return price
}

export const currencyOptions = [
  { label: "Pound Sterling", value: "pound sterling", symbol: "£", taxRate: 20 },
  { label: "Euro", value: "euro", symbol: "€", taxRate: 23 },
  { label: "US Dollar", value: "us dollar", symbol: "$", taxRate: 23 },
] as const

export type ICurrencySymbol = (typeof currencyOptions)[number]["symbol"]
export type ICurrencyValue = (typeof currencyOptions)[number]["value"]

export function getCurrencyOption(option?: string) {
  if (isEuros(option)) {
    return currencyOptions.find(v => v.symbol === "€")
  } else if (isPounds(option)) {
    return currencyOptions.find(v => v.symbol === "£")
  } else if (isDollars(option)) {
    return currencyOptions.find(v => v.symbol === "$")
  }
  return undefined
}

export function currencyNameToSymbol(currency_name: string) {
  const option = getCurrencyOption(currency_name)
  return option?.symbol ?? ""
}
